import { render, staticRenderFns } from "./FeatureUpdate.vue?vue&type=template&id=6427e994&"
import script from "./FeatureUpdate.vue?vue&type=script&lang=js&"
export * from "./FeatureUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports